<div class="row account-filter xs-mb-5 md-mb-15">
  <div class="col-sm-12 col-md-9 col-lg-9 col-xl-11 padding-l0 padding-r0 smallPadRgt0">
    <div class="row search-box-outer xs-mb-5 md-mb-10 md-mr-40">
      <div class="col-4 col-md-4 col-lg-3 padding-r0 borderRight category-drop-outer">
        <div class="category-dropdown material-select">
          <!--<ng-select name="ddlSearchCategory"
                     [items]="filterToApply"
                     [(ngModel)]="selectedFilter"
                     [virtualScroll]="true"
                     [closeOnSelect]="true"
                     [selectOnTab]="true"
                     [clearable]="false"
                     bindLabel="label"
                     bindValue="column"
                     [searchable]="false">
          </ng-select>-->
          <ng-select name="ddlSearchCategory"
                     [(ngModel)]="selectedFilter"
                     [virtualScroll]="true"
                     [closeOnSelect]="true"
                     [selectOnTab]="true"
                     [clearable]="false"
                     [searchable]="false"
                     data-testid="ddl-account-filter">
            <ng-option *ngFor="let option of filterToApply; let i = index;" [value]="option.column">
              <span [attr.data-testid]="'ddl-filter-select_'+i">{{option.label}}</span>
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="col-8 col-md-8 col-lg-9 padding-l0 padding-r0">
        <div class="material-select account-search">

          <div *ngIf="IsAccountTab">
            <div *ngIf="selectedFilter=='accountName'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input data-testid="ddl-accountname-search" (keyup.enter)="accountkeepFilter();" [(ngModel)]="filtersValue.accountName" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='account'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input data-testid="ddl-accountnumber-search" (keyup.enter)="accountkeepFilter();" [(ngModel)]="filtersValue.accountNo" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='city'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input data-testid="ddl-city-search" (keyup.enter)="accountkeepFilter();" [(ngModel)]="filtersValue.city" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <ng-select *ngIf="selectedFilter=='state'"
                       name="ddlstateSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="stateDS"
                       [(ngModel)]="filtersValue.state"
                       [multiple]="true"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       (change)="accountkeepFilter()"
                       data-testid="ddl-state-search">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template" [attr.data-testid]="'ddl-state-option_'+index">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>
            <ng-select *ngIf="selectedFilter=='accountTypeDescriptionWithCode'"
                       name="ddlaccountTypeSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="accountTypeDS"
                       [(ngModel)]="filtersValue.accountTypeDescriptionWithCode"
                       [multiple]="true"
                       [hideSelected]="true"
                       bindLabel="displayText"
                       bindValue="code"
                       [closeOnSelect]="true"
                       (change)="accountkeepFilter()"
                       data-testid="ddl-accounttype-search">
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div class="dropdown-template" [attr.data-testid]="'ddl-accounttype-option_'+index">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="name">
                        {{item.displayText}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>
            <div *ngIf="selectedFilter=='parentName'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input data-testid="ddl-parentname-search" (keyup.enter)="accountkeepFilter();" [(ngModel)]="filtersValue.parentName" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='parentNumber'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input data-testid="ddl-parentnumber-search" (keyup.enter)="accountkeepFilter();" [(ngModel)]="filtersValue.parentNumber" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="IsFulfilmentTab">

            <div *ngIf="selectedFilter=='accountName'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.accountName" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='account'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.accountNo" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='city'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.city" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='address'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.address" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='zip'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.zip" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='name'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.name" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='phoneNo'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.phoneNo" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>

            <ng-select *ngIf="selectedFilter=='state'"
                       name="ddlstateSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="stateDS"
                       [(ngModel)]="filtersValue.state"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [searchFn]="stateSearchFn"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}} ({{item.id}})
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <ng-select *ngIf="selectedFilter=='accountDDL'"
                       name="account"
                       [items]="accountDS"
                       placeholder="Search..."
                       [(ngModel)]="filtersValue.accountDDL"
                       [virtualScroll]="true"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [loading]="accountLoading"
                       class="custom-select-grower"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">

              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
              <ng-template ng-footer-tmp let-search="searchTerm">
                <div class="custom-drop-footer">
                  <div class="row">
                    <div class="col-md-8">Select an option above to filter</div>
                    <div class="col-md-4">{{this.accountDataCount}} Results</div>
                  </div>
                </div>
              </ng-template>
            </ng-select>

            <div *ngIf="selectedFilter=='itemNumber'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.itemNumber" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='productName'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.productName" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>

            <ng-select *ngIf="selectedFilter=='marketingBrand'"
                       name="ddlMbSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="marketingMasterList"
                       [(ngModel)]="filtersValue.marketingBrand"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="id"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <ng-select *ngIf="selectedFilter=='seedSize'"
                       name="ddlSSSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="seedSizeMasterList"
                       [(ngModel)]="filtersValue.seedSize"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="id"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <ng-select *ngIf="selectedFilter=='packageSize'"
                       name="ddlPSSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="packageSizeMasterList"
                       [(ngModel)]="filtersValue.packageSize"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="id"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <ng-select *ngIf="selectedFilter=='productCategory'"
                       name="ddlPCSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="productCategoryMasterList"
                       [(ngModel)]="filtersValue.productCategory"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="id"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <ng-select *ngIf="selectedFilter=='treatment'"
                       name="ddlTSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="treatmentMasterList"
                       [(ngModel)]="filtersValue.treatment"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="id"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <ng-select *ngIf="selectedFilter=='productLine'"
                       name="ddlPLSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="productLineMasterList"
                       [(ngModel)]="filtersValue.productLine"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="id"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <ng-select *ngIf="selectedFilter=='productSegment'"
                       name="ddlPSSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="productSegmentMasterList"
                       [(ngModel)]="filtersValue.productSegment"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="id"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <ng-select *ngIf="selectedFilter=='hybridVariety'"
                       name="ddlHVSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="hybridVarietyMasterList"
                       [(ngModel)]="filtersValue.hybridVariety"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="id"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <div *ngIf="selectedFilter=='dealerZip'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter();" [(ngModel)]="filtersValue.dealerZip" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>

            <ng-select *ngIf="selectedFilter=='branchPlant'"
                       name="ddlBPSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="branchPlantList"
                       [(ngModel)]="filtersValue.branchPlant"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>

            <ng-select *ngIf="selectedFilter=='orderType'"
                       name="ddlOTSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="requestTypeList"
                       [(ngModel)]="filtersValue.orderType"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       (change)="keepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div *ngIf="IsEmulationTab">
            <div *ngIf="selectedFilter=='accountName'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="emulationKeepFilter();" [(ngModel)]="filtersValue.accountName" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <ng-select *ngIf="selectedFilter=='account'"
                       name="account"
                       [items]="accountDS"
                       placeholder="Search..."
                       [(ngModel)]="filtersValue.account"
                       [virtualScroll]="true"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [loading]="accountLoading"
                       class="custom-select-grower"
                       [closeOnSelect]="true"
                       [searchFn]="emulationAccountFn"
                       (search)="emulationAccountSearchFn($event)"
                       (change)="emulationKeepFilter()">

              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
              <ng-template ng-footer-tmp let-search="searchTerm">
                <div class="custom-drop-footer">
                  <div class="row">
                    <div class="col-md-8">Select an option above to filter</div>
                    <div class="col-md-4 bold text-right">
                      Results : {{this.accountDataCount}}
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div *ngIf="selectedFilter=='accounttxt'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="emulationKeepFilter();" [(ngModel)]="filtersValue.account" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='city'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="emulationKeepFilter();" [(ngModel)]="filtersValue.city" placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <ng-select *ngIf="selectedFilter=='state'"
                       name="ddlstateSearch"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [items]="stateDS"
                       [(ngModel)]="filtersValue.state"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [searchFn]="stateSearchFn"
                       [closeOnSelect]="true"
                       (change)="emulationKeepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}} ({{item.id}})
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div *ngIf="IsPartnerWebSiteTab">
            <div *ngIf="selectedFilter=='accountName'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="emulationKeepFilter();" [(ngModel)]="filtersValue.accountName" placeholder="Search Accounts.." type="text">
                  </div>
                </div>
              </div>
            </div>
            <ng-select *ngIf="selectedFilter=='account'"
                       name="account"
                       [items]="accountDS"
                       placeholder="Search Accounts.."
                       [(ngModel)]="filtersValue.account"
                       [virtualScroll]="true"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [loading]="accountLoading"
                       class="custom-select-grower"
                       [closeOnSelect]="true"
                       [searchFn]="emulationAccountFn"
                       (search)="emulationAccountSearchFn($event)"
                       (change)="emulationKeepFilter()">

              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
              <ng-template ng-footer-tmp let-search="searchTerm">
                <div class="custom-drop-footer">
                  <div class="row">
                    <div class="col-md-8">Select an option above to filter</div>
                    <div class="col-md-4 bold text-right">
                      Results : {{this.accountDataCount}}
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div *ngIf="selectedFilter=='accounttxt'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="emulationKeepFilter();" [(ngModel)]="filtersValue.account" placeholder="Search Accounts.." type="text">
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedFilter=='city'">
              <div class="search-box-outer">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="emulationKeepFilter();" [(ngModel)]="filtersValue.city" placeholder="Search Accounts.." type="text">
                  </div>
                </div>
              </div>
            </div>
            <ng-select *ngIf="selectedFilter=='state'"
                       name="ddlstateSearch"
                       placeholder="Search Accounts.."
                       class="custom-select-grower"
                       [items]="stateDS"
                       [(ngModel)]="filtersValue.state"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [searchFn]="stateSearchFn"
                       [closeOnSelect]="true"
                       (change)="emulationKeepFilter()">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}} ({{item.id}})
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row selected-chip xs-pt-0 md-pt-10">
      <div class="col-9 col-md-10 ">
        <div>
          <mat-chip-set>
            <mat-chip selected *ngFor="let filterValue of filterValueList">
              {{filterValue.filterlabel}}
              <a href="Javascript:void(0);" (click)="clearFilter(filterValue.column)">
                <i class="fas fa-times text-right"></i>
              </a>
            </mat-chip>
          </mat-chip-set>
        </div>
      </div>
      <div class="col-3 col-md-2 text-right padding-r0" *ngIf="!IsPartnerWebSiteTab && filterValueList.length > 0">
        <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
      </div>
    </div>
  </div>

  <div *ngIf="!isFulfillment" class="col-md-2 col-lg-1 search-btn-outer text-center padding-r0 padding-l0">
    <div class="search-btn" [ngClass]="{'filterBtn': !IsEmulationTab}">
      <button mat-raised-button class="btns" [disabled]="disableSearchBtn" *ngIf="IsEmulationTab" color="primary" (click)="onFilter()">Search</button>
      <button data-testid="ddl-filter" mat-raised-button class="btns xs-button xs-full-width  md-mt-10 xs-mt-0" *ngIf="!IsEmulationTab" color="primary" (click)="onFilter()">Filter</button>
    </div>
  </div>
  <div class="col-md-2 col-lg-1 text-right padding-r0 padding-t20" *ngIf="IsPartnerWebSiteTab">
    <span>
      <a href="Javascript:void(0);" class="clearLink" (click)="clearAllFilter()">Clear All</a>
    </span>
  </div>
</div>
